module.exports = __webpack_public_path__ + "static/media/Track-trace-overview.9b473755.png";